module.exports = __webpack_public_path__ + "static/media/inktoberOwl.44572830.gif";